export default "__VITE_ASSET__yU5deQc8__"